<template>
	<div class="wrapper">
		<b-container>
			<b-row class="header-title">
				<h1 class="tit star">
					{{ $t('lang.Selectionrules') }}
				</h1>
			</b-row>
			<b-row>
				<div class="desc" v-html="rule.kpiRulesText"></div>
			</b-row>
			<!-- 时间轴part -->
			<!--   title  -->
			<div v-if="$i18n.locale == 'cn'">
				<b-row style="border-bottom: 1px solid #e9e9e9">
					<h1 class="tit time">
						{{ $t('lang.Nominatedtime') }}
					</h1>
				</b-row>
				<!-- 轴 -->
				<b-row class="time-item pt-5">
					<b-col cols="5"></b-col>
					<b-col cols="12" md="2">
						<div class="downAngle"></div>
					</b-col>
					<b-col cols="5"></b-col>
				</b-row>
				<b-row class="time-item">
					<b-col cols="5"></b-col>
					<b-col cols="12" md="2">
						<div class="center">
							<div class="line"></div>
						</div>
					</b-col>
					<b-col cols="5"></b-col>
				</b-row>
				<template v-for="(item, index) in timeList">
					<b-row :key="index" v-if="item.event" class="time-item">
						<b-col cols="5"></b-col>
						<b-col cols="12" md="2">
							<div class="circle">
								<span>{{ item.event }}</span>
							</div>
						</b-col>
						<b-col cols="5"></b-col>
					</b-row>
					<b-row :key="index" class="time-item">
						<template v-if="index % 2 == 0">
							<b-col cols="5"></b-col>
							<b-col cols="12" md="2">
								<div v-if="item.event" class="center">
									<div class="line"></div>
									<div
										v-if="item.titleItem"
										class="dot"
									></div>
								</div>
							</b-col>
							<b-col class="font-style right" cols="5"
								><div>{{ item.date }}</div>
								<div>{{ item.titleItem }}</div></b-col
							>
						</template>

						<template v-else>
							<b-col class="font-style text-right" cols="5"
								><div>{{ item.date }}</div>
								<div>{{ item.titleItem }}</div></b-col
							>
							<b-col cols="12" md="2">
								<div v-if="item.event" class="center">
									<div class="line"></div>
									<div
										v-if="item.titleItem"
										class="dot"
									></div>
								</div>
							</b-col>
							<b-col cols="5"></b-col>
						</template>
					</b-row>
				</template>
				<b-row class="time-item pb-5">
					<b-col cols="5"></b-col>
					<b-col cols="12" md="2">
						<div class="downAngle"></div>
					</b-col>
					<b-col cols="5"></b-col>
				</b-row>
			</div>
		</b-container>
	</div>
</template>
<script>
export default {
	data() {
		return {
			rule: {},
			timeList: [],
		}
	},
	created() {
		this.getAwardInfo(this.$route.query.type)
	},
	watch: {
		$route: {
			handler(val) {
				//新路由
				this.getAwardInfo(this.$route.query.type)
			},
		},
	},
	methods: {
		getAwardInfo(id) {
			this.$api
				.awardInfo({
					id: id,
				})
				.then((res) => {
					console.log(JSON.parse(res.data.kpiTimeText))
					this.rule = res.data
					let arr = JSON.parse(res.data.kpiTimeText)
					let eventArr = arr.filter((item) => {
						return item.date == ''
					})
					let dateArr = arr.filter((item) => {
						return item.date !== ''
					})
					// this.timeList = eventArr.map((item, index) => {
					//     item.title = dateArr[index].event;
					//     return item;
					// })
					this.timeList = eventArr.map((item, index) => {
						if (dateArr[index]) {
							item.date = dateArr[index].date
							item.titleItem = dateArr[index].event
						}
						return item
					})
					console.log(this.timeList)
				})
		},
	},
}
</script>
<style lang="scss" scoped>
.header-title{
		border-bottom: none;

	}
.tit {
	margin-left: 0.5rem;
	height: 6rem;
	line-height: 6rem;
	color: #cfaf75;
	padding-left: 5rem;
	transform: scale(0.82);
}
.desc::v-deep {
	color: #666666;
	font-size: 1.2rem;
	padding: 0;
	line-height: 2.6rem;
	padding-bottom: 4rem;
	p{
		transform: scale(0.9);
	}
}
.star {
	background: url(../../assets/sstar.png) no-repeat;
	background-position: 0 1.2rem;
}
.time {
	background: url(../../assets/sj.png) no-repeat;
	background-position: 0 1.2rem;
}
.center {
	height: 6rem;
}
.downAngle {
	margin: 0 auto;
	width: 0;
	height: 0;
	border-right: 0.4rem solid transparent;
	border-left: 0.4rem solid transparent;
	border-top: 0.4rem solid #b0b0b0;
}
.center {
	width: 6.5rem;
	height: 6.5rem;
	margin: 0 auto;
}
.line {
	margin: 0 auto;
	width: 0.2rem;
	height: 100%;
	background: #b0b0b0;
}
.circle {
	margin: 0 auto;
	height: 6.5rem;
	width: 6.5rem;
	border-radius: 50%;
	background: #c8a063;
	text-align: center;
	font-size: 16px;
	color: #ffffff;
	span {
		display: block;
		padding-top: 2.5rem;
	}
}
.dot {
	position: relative;
	top: -50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 0.8rem;
	height: 0.8rem;
	border-radius: 50%;
	background: #c99f63;
}
.time-item {
	position: relative;
	.font-style {
		position: absolute;
		color: #5d5d5d;
		font-size: 1.2rem;
	}
	.right {
		right: 0;
	}
}

// >678
@media (min-width: 768px) {
	.header-title{
		border-bottom: 1px solid #e9e9e9;

	}
	.tit{
		transform: scale(1);
	}
	.wrapper {
		min-width: 1200px;
	}
	.desc::v-deep{
		padding: 3rem;
		p{
			transform: scale(1);
		}
	}
	
	.time-item {
		.font-style {
			position: unset;
			color: #5d5d5d;
			font-size: 1.2rem;
		}
	}
	
}
</style>